import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-control",
  "use": "icon-control-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-control\"><path d=\"M725.333 234.667h-512c-36.266 0-64 27.733-64 64V832c0 36.267 27.734 64 64 64h512c36.267 0 64-27.733 64-64V298.667c0-36.267-27.733-64-64-64zM746.667 832c0 12.8-8.534 21.333-21.334 21.333h-512C200.533 853.333 192 844.8 192 832V298.667c0-12.8 8.533-21.334 21.333-21.334h512c12.8 0 21.334 8.534 21.334 21.334V832z\" /><path d=\"M832 128H298.667c-12.8 0-21.334 8.533-21.334 21.333s8.534 21.334 21.334 21.334H832c12.8 0 21.333 8.533 21.333 21.333v533.333c0 12.8 8.534 21.334 21.334 21.334S896 738.133 896 725.333V192c0-36.267-27.733-64-64-64zM597.333 725.333H320c-12.8 0-21.333 8.534-21.333 21.334S307.2 768 320 768h277.333c12.8 0 21.334-8.533 21.334-21.333s-8.534-21.334-21.334-21.334z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/control.svg
// module id = oiHZ
// module chunks = 65